import alert from './Alert.vue'
import carousel from './Carousel.vue'
import slider from './Slider.vue'
import accordion from './Accordion.vue'
import affix from './Affix.vue'
import aside from './Aside.vue'
import checkboxGroup from './checkboxGroup.vue'
import checkboxBtn from './checkboxBtn.vue'
import datepicker from './Datepicker.vue'
import dropdown from './Dropdown.vue'
import modal from './Modal.vue'
import option from './Option.vue'
import panel from './Panel.vue'
import popover from './Popover.vue'
import progressbar from './Progressbar.vue'
import radioBtn from './radioBtn.vue'
import radioGroup from './radioGroup.vue'
import select from './Select.vue'
import tab from './Tab.vue'
import tabset from './Tabset.vue'
import tooltip from './Tooltip.vue'
import typeahead from './Typeahead.vue'

const VueStrap = {
  alert,
  carousel,
  slider,
  accordion,
  affix,
  aside,
  checkboxBtn,
  checkboxGroup,
  datepicker,
  dropdown,
  modal,
  option,
  panel,
  popover,
  progressbar,
  radioGroup,
  radioBtn,
  select,
  tab,
  tabset,
  tooltip,
  typeahead
}

export default VueStrap



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/